export default __webpack_public_path__ + "media/images/images/gallery/24-5e7fb94a9b553b3f4ebd2d86d16bf9a2.jpg";